import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f757f5f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approve-reject-signup-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = {
  key: 0,
  class: "line1"
}
const _hoisted_4 = {
  key: 1,
  class: "line1"
}
const _hoisted_5 = { class: "body-main" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Status", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "LawID", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Title", -1))
const _hoisted_12 = {
  class: "row",
  style: {"width":"100%","display":"flex","flex-flow":"row nowrap"}
}
const _hoisted_13 = { style: {"width":"50%"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "First name:", -1))
const _hoisted_15 = { style: {"width":"50%"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Last name:", -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Email", -1))
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Firm name", -1))
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Address", -1))
const _hoisted_23 = {
  class: "row",
  style: {"width":"100%","display":"flex","flex-flow":"row nowrap"}
}
const _hoisted_24 = { style: {"width":"33.3%"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Suburb:", -1))
const _hoisted_26 = { style: {"width":"33.3%"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Postcode:", -1))
const _hoisted_28 = { style: {"width":"33.3%"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "State:", -1))
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Telephone number:", -1))
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Membership Type:", -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Publish on Web:", -1))
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Proof of External Examiner Course Completion:", -1))
const _hoisted_38 = { class: "file-list" }
const _hoisted_39 = { class: "file-item" }
const _hoisted_40 = { class: "file-name" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "row"
}
const _hoisted_43 = { class: "controls" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[2] || (_cache[2] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.actionType == 3)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "View External Examiner Sign up details"))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "External Examiner " + _toDisplayString(_ctx.actionType == 1 ? 'Approval' : 'Rejection'), 1))
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.actionType == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.eeSignUpForm.eeSignUpFormStatus.name == 'Rejected' ? 'error' : '')
                      }, _toDisplayString(_ctx.eeSignUpForm.eeSignUpFormStatus.name), 3)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.lawId), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.title), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.firstName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.surname), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.email), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.firmName), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.address), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.suburb), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.postCode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.state), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.phoneDetail?.countryCode) + " " + _toDisplayString(_ctx.eeSignUpForm.phoneDetail?.phoneNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.eeMembershipType?.name?? ''), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", null, _toDisplayString(_ctx.eeSignUpForm.publishOnWeb ? 'Yes' : 'No'), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEESignUpForm.files, (f) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(f.fileName), 1),
                        _createElementVNode("button", {
                          class: "btn btn-secondary sml",
                          onClick: $event => (_ctx.downloadFile(f))
                        }, "Download", 8, _hoisted_41)
                      ]))
                    }), 256))
                  ])
                ]),
                (_ctx.actionType != 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      (_ctx.actionType==1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" Are you sure you want to approve this External Examiner? ")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" Are you sure you want to reject this External Examiner? ")
                          ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          (_ctx.submitting || _ctx.loadingContent)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator mr-2",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-default ml-1",
            disabled: _ctx.submitting || _ctx.loadingContent,
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, _toDisplayString(_ctx.actionType == 1 ||  _ctx.actionType == 2 ? 'Cancel' : 'Close'), 9, _hoisted_44),
          (_ctx.actionType != 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary",
                disabled: _ctx.submitting || _ctx.loadingContent,
                onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.mainActionButClicked()), ["prevent","stop"]))
              }, [
                _createTextVNode(_toDisplayString(_ctx.actionType == 1 ? 'Approve' : 'Reject'), 1),
                _hoisted_46
              ], 8, _hoisted_45))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}